import React, { ReactNode } from 'react'
import { useQueries } from '@tanstack/react-query'
import { getGroupSubtitle } from '../helpers'
import { theme } from '../../../../theme/theme'
import { RegisterGroupMemberUserListItem } from './RegisterGroupMemberUserListItem'
import { Dropdown, Option } from '../../../common/Dropdown'
import { Button, ButtonVariant } from '../../../common/Button'
import { IconChoices } from '../../../common/Icon'
import { useAppTranslation } from '../../../../hooks/useAppTranslation'
import { IGroupModel } from '../../../../interfaces/models/groups.interfaces'
import { userQueries } from '../../../../api/users'

interface RegisterGroupMemberListItemProps {
  group: IGroupModel
  dropdownOptions: Option[]
  className?: string
}

export const RegisterGroupMemberListItem = ({
  group,
  dropdownOptions,
  className,
}: RegisterGroupMemberListItemProps): ReactNode => {
  const { translate } = useAppTranslation()
  const usersQuery = useQueries({
    queries:
      group.membersList?.map((member) => {
        return userQueries.getUser(member.userId)
      }) || [],
  })

  const users = usersQuery.flatMap((query) => query.data || [])

  return (
    <div className={`md:w-1/2 ${className ?? ''}`}>
      <div className="flex items-center justify-between">
        <div>
          <p style={theme.textVariants.h3}>{group.name}</p>
          <p style={theme.textVariants.base}>{getGroupSubtitle(group)}</p>
        </div>
        <Dropdown dropdownPosition="bottom-left" options={dropdownOptions}>
          <Button
            label={translate('common.options')}
            variant={ButtonVariant.DEFAULT}
            size="sm"
            icon={IconChoices.MORE}
            iconPlacement="right"
          />
        </Dropdown>
      </div>
      {group.membersList?.map((_member, index) => {
        const _user = users.find((user) => user._id === _member.userId)
        if (_user) {
          return (
            <RegisterGroupMemberUserListItem
              key={_member.userId}
              user={_user}
              className={`
                  ${index === 0 ? 'mt-2 rounded-t-md border-t' : ''}
                  ${
                    group.membersList && index === group.membersList.length - 1
                      ? 'rounded-b-md'
                      : ''
                  }
                `}
            />
          )
        }
        return null
      })}
    </div>
  )
}
